<script>
import _find from 'lodash/find'
import _debounce from 'lodash/debounce'
import Loading from '@components/custom-loading'

export default {
  components: { Loading },
  props: {
    options: { type: Array, default: () => [] },
    fetchingData: { type: Boolean, default: false },
  },
  data() {
    return {
      selected: '',
      keyword: '',
    }
  },
  computed: {
    showLoadMore() {
      return this.options.length % 100 === 0
    },
  },
  watch: {
    keyword: function(newVal, oldVal) {
      this.debounce(newVal)
    },
    selected: function(newVal, oldVal) {
      var val = _find(this.options, v => v.id === newVal)
      if (val) {
        this.$emit('updateSelected', [val])
      }
    },
    options: {
      handler: function(newVal, oldVal) {
        var option = _find(newVal, opt => opt.checked)
        this.selected = option ? option.id : ''
      },
      deep: true,
    },
  },
  created() {
    this.debounce = _debounce(this.updateKeyword, 500)
  },
  methods: {
    updateKeyword(newVal) {
      this.$emit('updateKeyword', newVal)
    },
    loadMore() {
      this.$emit('loadMore')
    },
  },
}
</script>

<template>
  <div class="reports-single-select">
    <div class="search-bar">
      <v-icon class="search-icon">search</v-icon>
      <input
        v-model="keyword"
        type="text"
        class="input-style"
        aria-label="search input">
    </div>
    <div
      id="select-options"
      class="select-options">
      <Loading v-if="fetchingData"/>
      <div v-else>
        <v-radio-group
          v-model="selected"
          column>
          <v-radio
            v-for="{id, name} in options"
            :key="id"
            :label="name"
            :value="id"
            color="grey"
            class="custom-radio"
          />
        </v-radio-group>
        <a
          v-if="showLoadMore"
          class="load-more"
          @click="loadMore">Load More</a>
      </div>
    </div>
  </div>
</template>

<style scoped>
.reports-single-select {
  border: 1px solid #e6e6e6;
  width: 100%;
  height: 335px;
}
.search-bar {
  height: 40px;
  border-bottom: 1px solid #e6e6e6;
}
.search-icon {
  margin-left: 15px;
  width: 10%;
}
.input-style {
  height: 100%;
  width: 80%;
  font-size: 14px;
  font-size: 1rem;
}
.custom-radio {
  height: 25px;
}
.custom-radio >>> label {
  font-size: 14px;
  font-size: 1rem;
  width: auto;
}
.custom-radio > label:hover,
.radio-group [aria-checked='true'] {
  font-weight: bold;
  color: black;
}
.select-options {
  height: 272px;
  overflow-y: scroll;
  margin: 0px 20px;
}
.select-options >>> .input-group__details {
  display: none;
}
.load-more {
  margin-top: 10px;
  display: inline-block;
}
.load-more:hover {
  font-weight: bold;
}
</style>
